import { useState, useEffect, useRef, useCallback } from "react";
import { generatePath, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import http from "../../api/server";
import useGetClientId from "../../hooks/useGetClientId";
import {
  ADD_BLOCK_BY_CLIENT_ID,
  ADD_PROPERTY_BY_CLIENT_ID,
  CREATE_BLOCKS,
  GET_USERS_ROLE_BY_CLIENT_ID,
  CHECK_COMPANY_CLIENTNAME,
  SELECT_CLIENT,
  //   POST_PROPERTY_FLOOR_IAMGE,
} from "../../api/apiPath";
import Toaster from "../common/Toaster";
import { hostName } from "../../config/config";
import { useSelector } from "react-redux";
import FileUpload from "../common/FileUpload";
import useGetCity from "../../hooks/useGetCity";
import LoadingComponent from "../common/LoadingComponent";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import SidebarIcons from "../common/SidebarIcons";
import delicon from "../../assets/img/del.png";
import AutocompleteInput from "../common/AutocompleteInput";
import ConfirmationPopup from "../common/ConfirmationPopup";

const AddBlockModalPopup = ({
  setShowAddBlockModal,
  addNewBlockValue,
  setAddNewBlockValue,
  handleAddBlock,
  hanleSaveBlock,
}) => {
  return (
    <div className="dashboard_body_main d-flex vh-100">
      <div className="d-flex dashboard_body flex-column py-3 ">
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "fit-content" }}
          >
            <span
              className="close"
              onClick={() => {
                setShowAddBlockModal(false);
                setAddNewBlockValue("");
              }}
            >
              &times;
            </span>
            <h6 className="modal-header">Add Block</h6>

            <div className="modal-body">
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="address1"
                  placeholder=" "
                  value={addNewBlockValue}
                  onChange={handleAddBlock}
                  required
                />
                <label htmlFor="address1">Add Block</label>
              </div>

              <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-3">
                <button
                  type="button"
                  className="btn btn-tertiary"
                  onClick={() => {
                    setShowAddBlockModal(false);
                    setAddNewBlockValue("");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={hanleSaveBlock}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddSiteBlock = () => {
  const fileInputRef = useRef(null);
  const { userObj } = useSelector((state) => state.user);
  //   const [blocksList, setBlocksList] = useState(null);
  const [approverList, setApproverList] = useState(null);
  const [inspectorList, setInspectorList] = useState(null);
  const [showAddBlockModal, setShowAddBlockModal] = useState(false);
  const [propertyName, setPropertName] = useState("");
  const [propertyAddress, setPropertAddress] = useState("");
  //   const [totalFloor, setTotalFloor] = useState("");
  const [propertyPostalCode, setPropertPostalCode] = useState("");
  //eslint-disable-next-line no-unused-vars
  const [propertImage, setPropertyImage] = useState("");
  //eslint-disable-next-line no-unused-vars
  const [previewPropertImage, setPreviewPropertImage] = useState("");
  //   const [propertyBlockObj, setPropertyBlockName] = useState("");
  const [addNewBlockValue, setAddNewBlockValue] = useState("");
  const [propertyCity, setPropertyCity] = useState("");
  const [propertyStatus, setPropertyStatus] = useState("Active");
  const [propertyInspector, setPropertyInspector] = useState([]);
  const [propertyApprover, setPropertyApprover] = useState([]);
  const [numberofBlocks, setNumberofBlocks] = useState(0);
  const [siteLatitude, setSiteLatitude] = useState("");
  const [siteLongitude, setSiteLongitude] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [showNewCityInput, setShowNewCityInput] = useState(false);
  const [newCityName, setNewCityName] = useState("");
  const [cityError, setCityError] = useState("");

  const [validationFlag, setValidationFlag] = useState(false);
  const [files, setFiles] = useState([]);
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(false);
  const cityObj = useGetCity();
  const [errorPostCode, setErrorPostCode] = useState("");

  // Client selection states
  const [clientsList, setClientsList] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [showNewClientInput, setShowNewClientInput] = useState(false);
  const [newClientName, setNewClientName] = useState("");
  const [clientError, setClientError] = useState("");
  const clientRef = useRef(null);

  const [hideSidebar, setHideSidebar] = useState(false);
  const navigate = useNavigate();

  // Confirmation popup state for delete/cancel actions.
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });

  // const [addressSuggestions, setAddressSuggestions] = useState([]);
  // const [showSuggestions, setShowSuggestions] = useState(false);
  // const [isLoadingAddress, setIsLoadingAddress] = useState(false);
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (addressRef.current && !addressRef.current.contains(event.target)) {
  //       setShowSuggestions(false); // closes the dropdown
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside); // listen for clicks outside

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside); // cleanup on unmount
  //   };
  // }, []);
  // const handleAddressSearch = async (query) => {
  //   if (!query || query.length < 2) {
  //     setAddressSuggestions([]);
  //     setShowSuggestions(false);
  //       // Clear latitude & longitude
  //     setSiteLatitude("");
  //     setSiteLongitude("");
  //     return;
  //   }

  //   setIsLoadingAddress(true);
  //   setShowSuggestions(true);

  //   try {
  //     const response = await fetch(
  //       `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
  //         query
  //       )}&format=json&addressdetails=1&limit=20`,
  //       {
  //         headers: {
  //           "Accept": "application/json",
  //           "User-Agent": "IDS-Property-Search/1.0",
  //         },
  //       }
  //     );

  //     const data = await response.json();

  //     const formattedAddresses = data.map((item) => ({
  //       display_name: item.display_name,
  //       lat: item.lat,
  //       lon: item.lon,
  //     }));

  //     setAddressSuggestions(formattedAddresses);
  //   } catch (error) {
  //     console.error("Address search failed", error);
  //     setAddressSuggestions([]);
  //   } finally {
  //     setIsLoadingAddress(false);
  //   }
  // };

  // const handleSelectAddress = (item) => {
  //   setPropertAddress(item.display_name);

  //   setSiteLatitude(item.lat);
  //   setSiteLongitude(item.lon);

  //   setShowSuggestions(false);
  //   setAddressSuggestions([]);
  // };

  //   const [floorError, setFloorError] = useState("");
  //   const [showFloorImages, setShowFloorImages] = useState(false);
  const { clientNameParam } = useParams();

  const [activeTab, setActiveTab] = useState("Site"); //or Block

  const handleTabChange = (e) => {
    setActiveTab(e);
    setValidationFlag(false);
  };
  const [errors, setErrors] = useState({});

  //   const blockRef = useRef(null);
  const nameRef = useRef(null);
  const addressRef = useRef(null);
  const cityRef = useRef(null);
  const postalCodeRef = useRef(null);
  //   const totalFloorRef = useRef(null);
  const inspectorRef = useRef(null);
  const approverRef = useRef(null);
  const numberofBlocksref = useRef(null);
  const latitudeRef = useRef(null);
  const longitudeRef = useRef(null);
  const blockRef = useRef([]);

  // const handleCityChange = (e) => {
  //   cityRef.current.style.border = "";
  //   const selectedCountry = e.target.value;
  //   setPropertyCity(selectedCountry);
  //   console.log("Selected country:", selectedCountry);
  //   setErrors({});
  // };

  const handleCityChange = (val) => {
    cityRef.current && (cityRef.current.style.border = "");
    setPropertyCity(val);
  };

  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);
  //   const [floorEntries, setFloorEntries] = useState([]);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  // const navigate = useNavigate();
  const clientObj = useGetClientId();

  // Options for the floor number dropdown
  //   const floorOptions = Array.from({ length: totalFloor }, (_, i) => i + 1); // Floors 1-10

  // Function to add a new floor entry
  //   const handleAddFloor = () => {
  //     setFloorEntries([...floorEntries, { floor: "", image: null }]);
  //   };

  // Function to remove a floor entry by index
  //   const handleRemoveFloor = (index) => {
  //     const newFloorEntries = floorEntries.filter((_, i) => i !== index);
  //     setFloorEntries(newFloorEntries);
  //   };

  // Function to handle floor number change for a specific entry
  //   const handleFloorChange = (index, value) => {
  //     const newFloorEntries = [...floorEntries];
  //     newFloorEntries[index].floor = value;
  //     newFloorEntries[index].requireFloor = "";
  //     setFloorEntries(newFloorEntries);
  //   };

  // Function to handle image file selection for a specific entry
  //   const handleImageChange = (index, file) => {
  //     const newFloorEntries = [...floorEntries];
  //     newFloorEntries[index].image = file;
  //     newFloorEntries[index].requireImage = "";
  //     setFloorEntries(newFloorEntries);
  //   };

  //   const checkFloorEntries = (entries) => {
  //     const isObjectValuesEmpty = (obj) => {
  //       return Object.values(obj).every(
  //         (value) =>
  //           value === null ||
  //           value === undefined ||
  //           value === "" ||
  //           value === "Select" ||
  //           value === "Please select floor" ||
  //           value === "Please upload floor plan image"
  //       );
  //     };

  //     return entries.every(isObjectValuesEmpty);
  //   };

  //   const validateFloorEntries = (cleanedFloor) => {
  //     const isEmptyFloorEntries = checkFloorEntries(floorEntries);
  //     const newFloorEntries = [...cleanedFloor];
  //     if (floorEntries.length > 0 && !isEmptyFloorEntries) {
  //       newFloorEntries.forEach((entry) => {
  //         if (entry.floor !== "Select" && entry.floor !== "" && !entry.image)
  //           entry.requireImage = "Please upload floor plan image";
  //         if (entry.image && (!entry.floor || entry.floor === "Select"))
  //           entry.requireFloor = "Please select floor";
  //       });
  //     }
  //     return newFloorEntries;
  //   };

  //   const getBlockByClientID = async (clientId) => {
  //     try {
  //       const response = await http.get(
  //         GET_BLOCK_BY_CLIENT_ID + "?clientId=" + clientId
  //       );
  //       if (response.status === 200) {
  //         setBlocksList(response?.data?.blocks);
  //       }
  //     } catch (error) {
  //       return error;
  //     }
  //   };
  // Prepare city dropdown options, including a fallback option for adding a new city.
  const cityOptions = [
    { cityId: "add-new", cityName: "➕ Others" },
    ...(city || []),
  ].sort((a, b) =>
    (a.cityName || "").localeCompare(b.cityName || "", undefined, {
      sensitivity: "base",
    }),
  );
  // Load inspector/approver dropdown options for the current client.
  const getUsersRoleByClientId = async (clientId) => {
    try {
      const response = await http.get(
        GET_USERS_ROLE_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        // Filter roles
        const approvers = response?.data?.filter(
          (item) => item.roleName === "Approver" && item.active === true,
        );
        const inspectors = response?.data?.filter(
          (item) => item.roleName === "Inspector" && item.active === true,
        );

        // Dropdown options
        const approverOptions = approvers.map((a) => ({
          value: a.userId,
          label: a.fullName,
        }));

        const inspectorOptions = inspectors.map((i) => ({
          value: i.userId,
          label: i.fullName,
        }));
        setInspectorList(inspectorOptions);
        setApproverList(approverOptions);
      }
    } catch (error) {
      return error;
    }
  };

  // Load the company clients list for the current client context.
  const getCompanyClients = useCallback(async () => {
    try {
      const res = await http.get(
        // `/api/Client/GetCompanyClientMappings?clientId=${clientObj.clientId}`,
        `${SELECT_CLIENT}?clientId=${clientObj.clientId}`,
      );

      if (res.status === 200) {
        setClientsList(res.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch company clients", err);
    }
  }, [clientObj.clientId]);

  useEffect(() => {
    if (clientObj.clientId) {
      getCompanyClients();
    }
  }, [clientObj.clientId, getCompanyClients]);

  useEffect(() => {
    if (!files || files.length === 0) return;

    const hasError = files.some(
      (f) =>
        !f.docName?.trim() ||
        !f.type ||
        (f.file && f.file.size > 10 * 1024 * 1024),
    );

    if (!hasError) {
      setError("");
      setShowValidation(false);
    }
  }, [files]);
  useEffect(() => {
    if (!blockData || blockData.length === 0) return;

    setBlockData((prev) =>
      prev.map((block) => {
        if (!block.additionalDocsArr || block.additionalDocsArr.length === 0) {
          return {
            ...block,
            fileError: "",
            fileShowValidation: false,
          };
        }

        const hasError = block.additionalDocsArr.some(
          (f) =>
            !f.docName?.trim() ||
            !f.type ||
            (f.file && f.file.size > 10 * 1024 * 1024),
        );

        if (!hasError) {
          return {
            ...block,
            fileError: "",
            fileShowValidation: false,
          };
        }

        return block;
      }),
    );
  }, [blockData]);

  useEffect(() => {
    if (selectedClient === "") {
      setShowNewClientInput(false);
      setNewClientName("");
    }
  }, [selectedClient]);
  

  // When selectedClient is cleared, show dropdown again
  // useEffect(() => {
  //   if (!selectedClient || selectedClient.trim() === "") {
  //     setShowNewClientInput(false);
  //     setNewClientName("");
  //   }
  // }, [selectedClient]);

  useEffect(() => {
    if (clientObj.clientId) {
      //   getBlockByClientID(clientObj.clientId);
      getUsersRoleByClientId(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  // Handle selecting an image file for the site and create a local preview URL.
  //eslint-disable-next-line no-unused-vars
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setPropertyImage(file);
    setPreviewPropertImage(URL.createObjectURL(file));
  };

  //   const handleSelect = (e) => {
  //     const foundObject = blocksList.find(
  //       (option) => option.blockName === e.target.value
  //     );
  //     setPropertyBlockName(foundObject);
  //   };

  const hanleSaveBlock = async () => {
    try {
      const response = await http.post(ADD_BLOCK_BY_CLIENT_ID, {
        clientId: clientObj.clientId,
        blockName: addNewBlockValue,
      });
      if (response.status !== 400) {
        setShowAddBlockModal(false);
        setAddNewBlockValue("");
        // getBlockByClientID(clientObj.clientId);
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response?.data?.message,
        });
      }
    } catch (error) {
      return error;
    }
  };

  const handleAddBlock = (e) => {
    setAddNewBlockValue(e.target.value);
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };
  const floorInputRef = useRef({});
  const handleResetAddPropertyForm = () => {
    setAddNewBlockValue("");
    setPropertAddress("");
    // setTotalFloor("");
    setNumberofBlocks(0);
    setSiteLatitude("");
    setSiteLongitude("");
    setPropertName("");
    setPropertPostalCode("");
    // setPropertyBlockName("");
    setPropertyCity("");
    setPropertyImage("");
    setPreviewPropertImage("");
    resetFileInput();
    setPropertyInspector(null);
    setPropertyApprover(null);
    setErrorPostCode("");
    // setFloorError("");
    setValidationFlag(false);
    // Reset client-related states
    setSelectedClient("");
    setShowNewClientInput(false);
    setNewClientName("");
    setClientError("");
    setErrors({
      siteName: "",
      address: "",
      siteLatitude: "",
      siteLongitude: "",
      numberofBlocks: "",
      inspector: "",
      approvers: "",
      client: "",
    });
    setFiles([]);
    // setFloorEntries([{ floor: "", image: null }]);
    Object.values(floorInputRef.current).forEach((input) => {
      if (input) input.value = "";
    });
  };
  const [error, setError] = useState("");
  const [showValidation, setShowValidation] = useState(false);
  // const fileToBase64 = (file) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result.split(",")[1]); // remove "data:..;base64,"
  //     reader.onerror = reject;
  //     // reader.readAsDataURL(file);
  //   });

  //   const checkFloorPlanDataIsAvailable = () => {
  //     if (floorEntries.length === 1 || floorEntries.length > 1) {
  //       if (floorEntries[0].floor && floorEntries[0].image) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   };

  // Convert the chosen compliance documents list into a payload shape expected by the API.
  const buildPayload = async (entries) => {
    const payload = await Promise.all(
      entries.map(async (fe) => ({
        complianceType: fe.type, // from dropdown
        complianceFileName: fe.docName, // editable name
        complianceFile: fe.file, // base64 string
      })),
    );
    console.log("buildPayload", payload);
    return payload;
  };
  const getPropertyId = (str) => {
    if (!str) return null; // safety check

    // Check if "=" exists
    if (str.includes("=")) {
      return str.split("=")[1]; // take value after "="
    }
    return str; // return original if "=" not present
  };
  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;

  const isValidUKLatitude = (lat) => {
    const num = Number(lat);
    return !Number.isNaN(num) && num >= 49.5 && num <= 61;
  };

  const isValidUKLongitude = (lng) => {
    const num = Number(lng);
    return !Number.isNaN(num) && num >= -8 && num <= 2;
  };

  // Validate both site-level and building-level form sections.
  const validate = () => {
    let isValid = {
      site: true,
      block: true,
    };
    const newErrors = {};

    for (const fe of files) {
      if (!fe.docName.trim()) {
        setError("Each file must have a document name.");
        setShowValidation(true);
        isValid.site = false;
        setValidationFlag(true);
      }
      if (!fe.type) {
        setError("Each file must have a type selected.");
        setShowValidation(true);
        isValid.site = false;
        setValidationFlag(true);
      }
      if (fe.file && fe.file.size > 10 * 1024 * 1024) {
        setError("Each file should not exceed 10 MB");
        setShowValidation(true);
        isValid.site = false;
        setValidationFlag(true);
      }
    }

    if (!propertyName.trim()) {
      isValid.site = false;
      //   nameRef.current.style.border = "1px solid red";
      newErrors.siteName = "Site name is required";
    }
    if (!propertyAddress.trim()) {
      isValid.site = false;
      //   addressRef.current.style.border = "1px solid red";
      newErrors.address = "Site address is required";
    }
    // if (!propertyCity) {
    //   isValid.site = false;
    //   //   cityRef.current.style.border = "1px solid red";
    //   newErrors.cityid = "City is required";
    // }
    if (!propertyCity) {
      isValid.site = false;
      // cityRef.current.style.border = "3px solid red";
      newErrors.cityid = "City is required";
    } else if (propertyCity === "add-new" && !newCityName.trim()) {
      isValid.site = false;
      // cityRef.current.style.border = "2px solid red";
      newErrors.cityid = "Please enter new city name";
    }
    if (
      !numberofBlocks ||
      !Number.isInteger(Number(numberofBlocks)) ||
      Number(numberofBlocks) < 1
    ) {
      isValid.site = false;
      newErrors.numberofBlocks =
        "Total buildings must be a positive integer between 1 - 200";
    }
    if (siteLatitude && !isValidUKLatitude(siteLatitude)) {
      isValid.site = false;
      //   latitudeRef.current.style.border = "1px solid red";
      newErrors.siteLatitude = "Enter valid UK Latitude";
    }
    if (siteLongitude && !isValidUKLongitude(siteLongitude)) {
      isValid.site = false;
      //   longitudeRef.current.style.border = "1px solid red";
      newErrors.siteLongitude = "Enter valid UK Longitude";
    }
    // if (!propertyPostalCode.trim()) {
    //   isValid.site = false;
    //   //   postalCodeRef.current.style.border = "1px solid red";
    //   setErrorPostCode("Postal Code is required");
    // }
    // if (
    //   propertyPostalCode &&
    //   !ukPostcodeRegex.test(propertyPostalCode.trim())
    // ) {
    //   isValid.site = false;
    //   //postalCodeRef.current.style.border = "1px solid red";
    //   postalCodeRef.current?.style &&
    //     (postalCodeRef.current.style.border = "1px solid red");
    //   setErrorPostCode("Invalid UK Postal Code");
    // } else {
    //   setErrorPostCode("");
    // }

    if (!propertyPostalCode.trim()) {
      isValid.site = false;
      setErrorPostCode("Postal Code is required");
      postalCodeRef.current?.style &&
        (postalCodeRef.current.style.border = "1px solid red");
    } else if (!ukPostcodeRegex.test(propertyPostalCode.trim())) {
      isValid.site = false;
      setErrorPostCode("Invalid UK Postal Code");
      postalCodeRef.current?.style &&
        (postalCodeRef.current.style.border = "1px solid red");
    } else {
      setErrorPostCode("");
      postalCodeRef.current?.style && (postalCodeRef.current.style.border = "");
    }

    if (!propertyInspector || propertyInspector.length === 0) {
      //   inspectorRef.current?.controlRef?.style?.setProperty(
      //     "border",
      //     "1px solid red"
      //   );
      newErrors.inspector = "Inspector is required";
      isValid.site = false;
    }

    if (!propertyApprover || propertyApprover.length === 0) {
      //   approverRef.current?.controlRef?.style?.setProperty(
      //     "border",
      //     "1px solid red"
      //   );
      newErrors.approvers = "Approver is required";
      isValid.site = false;
    }

    // Client validation
    // if (
    //   (!selectedClient || selectedClient === "") &&
    //   !newClientName.trim()
    // ) {
    //   newErrors.client = "Client is required";
    //   isValid = false;

    //   if (clientRef.current) {
    //     clientRef.current.style.border = "1px solid red";
    //   }
    // }

    //block data validation
    if (!blockData || blockData.length === 0) {
      newErrors.buildingRequired = "At least 1 building required";
    }

    const blockFileErrors = blockData.some((block, blockIndex) => {
      let hasFileError = false;

      for (const file of block.additionalDocsArr) {
        if (!file.docName.trim()) {
          handleBlockDataChange(
            blockIndex,
            "fileError",
            "Each file must have a document name.",
          );
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
        if (!file.type) {
          handleBlockDataChange(
            blockIndex,
            "fileError",
            "Each file must have a type selected.",
          );
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
        if (file.file && file.file.size > 10 * 1024 * 1024) {
          handleBlockDataChange(
            blockIndex,
            "fileError",
            "Each file must not exceed 10 MB.",
          );
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
      }

      if (!hasFileError && block.additionalDocsArr.length > 0) {
        handleBlockDataChange(blockIndex, "fileError", "");
        handleBlockDataChange(blockIndex, "fileShowValidation", false);
      }

      return hasFileError;
    });

    if (blockFileErrors) {
      isValid.block = false;
      setValidationFlag(true);
    }

    const isPositiveInt = (n) => Number.isInteger(n) && n > 0 && n <= 200;

    const invalids = blockData
      .map((b, i) => ({
        index: i,
        id: b.id,
        blockNameEmpty: !String(b.blockName || "").trim(),
        totalFloorsInvalid: !isPositiveInt(Number(b.totalFloors)),
      }))
      .filter((x) => x.blockNameEmpty || x.totalFloorsInvalid);

    const allFloorsHaveNumbersForAllBlocks = blockData.every(
      (block) =>
        block.floorArray.length > 0 &&
        block.floorArray.every((f) => f.floor !== null && f.floor !== "") &&
        new Set(block.floorArray.map(f => f.floor)).size === block.floorArray.length,
    );

    console.log("floor numbers", allFloorsHaveNumbersForAllBlocks, blockData);

    if (invalids.length > 0 || !allFloorsHaveNumbersForAllBlocks) {
      isValid.block = false;
      setBlockData((prev) =>
        prev.map((b) => {
          const nameEmpty = !String(b.blockName || "").trim();
          const floorsInvalid =
            !Number.isInteger(Number(b.totalFloors)) ||
            Number(b.totalFloors) <= 0;

          //floor number validations
          const floorErrorsMap = validateAndFlagFloors(b.floorArray);
          const hasFloorErrors = floorErrorsMap.size > 0;

          //floor image validations
          // const mustHaveImages = b.totalFloors > 0;

          // const nextFloors = b.floorArray.map((f) => {
          //   const missing = mustHaveImages && f.image == null;
          //   return {
          //     ...f,
          //     floorError: missing ? "Floor image is required" : "",
          //   };
          // });

          return {
            ...b,
            // You already have fileError/fileShowValidation; add form errors:
            formErrors: {
              ...b.formErrors,
              blockName: nameEmpty ? "Block name is required" : "",
              totalFloors: floorsInvalid
                ? "Total floors must be a positive integer between 1 - 200"
                : "",
              floorNumbers: hasFloorErrors
                ? "Please check highlighted floors for errors"
                : "",
            },
            hasFormErrors: nameEmpty || floorsInvalid || hasFloorErrors,
            floorArray: b.floorArray.map((f) => ({
              ...f,
              floorNumberError: floorErrorsMap.get(f.floorTempid) || "",
            })),
          };
        }),
      );
    }

    setErrors(newErrors);
    return isValid;
  };

  const validateAndFlagFloors = (floorArray) => {
    const parsed = floorArray.map((f) => ({
      index: f.floorTempid,
      value: f.floor === "" || f.floor === null ? NaN : Number(f.floor),
    }));

    const errors = new Map(); // index => error message

    //remove invalid/empty numbers
    const validNumbers = parsed.filter(
      (f) => !Number.isNaN(f.value)
    );

    //✅ 1. Duplicate detection (negative-safe)

    const seen = new Map(); // value -> first index

      validNumbers.forEach(({ index, value }) => {
        if (seen.has(value)) {
          errors.set(index, "Duplicate floor number");
        } else {
          seen.set(value, index);
        }
      });

    // ✅ 2. Sequence validation

    // for (let i = 1; i < validNumbers.length; i++) {
    //     const prev = validNumbers[i - 1];
    //     const current = validNumbers[i];

    //     if (current.value !== prev.value + 1) {
    //       errors.set(
    //         current.index,
    //         "Floor numbers must be sequential"
    //       );
    //       break; // flag only the first break
    //     }
    //   }

    //3. empty/invalid number check
    parsed.forEach((item) => {
      if (Number.isNaN(item.value)) {
        errors.set(item.index, "Floor number must be a valid integer");
      }
    });

    return errors; // Map<floorIndex, errorMessage>
  };

  const checkCompanyClient = async () => {
    if ((!selectedClient || selectedClient === "") && !newClientName.trim()) {
      return true;
    }
    const params = new URLSearchParams();
    params.append("clientId", clientObj?.clientId);
    params.append("companyClientName", newClientName);
    const queryString = params.toString();
    try {
      const response = await http.get(
        CHECK_COMPANY_CLIENTNAME + `?${queryString}`,
      );
      if (response.status === 200) {
        console.log("res", response);
        return response?.data;
      }
    } catch (err) {
      console.log("err in client name check", err);
    }
  };

  // Save the site and associated building details to the server.
  const handleSaveProperty = async () => {
    // event.preventDefault();
    // setSaving(true);
    setValidationFlag(false);
    setShowValidation(false);
    setLoading(true);
    // Client validation (only when field is enabled)
    if (
      (!selectedClient ||
        selectedClient === "" ||
        selectedClient === "add-new") &&
      newClientName
    ) {
      const isExistClientname = await checkCompanyClient();
      if (isExistClientname) {
        if (clientRef.current) {
          clientRef.current.style.border = "1px solid red";
        }
        setErrors({ ...errors, client: "clientname already exists" });
        setValidationFlag(true);
        setLoading(false);
        clientRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        clientRef.current.focus();
        return;
      }
    }
    const isValid = validate();

    if (!isValid.site || !isValid.block) {
      setValidationFlag(true);
      if (!isValid.site) {
        setActiveTab("Site");
        setTimeout(() => {
          nameRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 500);
      } else if (!isValid.block) {
        setActiveTab("Block");
        // setTimeout(() => {
        //     blockRef.current.scrollIntoView({
        //     behavior: "smooth",
        //     block: "center",
        //   });
        //   }, 500);
        const firstInvalidBlockIndex = blockData.filter(
          (b) => b.hasFormErrors || b.fileShowValidation,
        )[0]?.id;
        setTimeout(() => {
          if (
            firstInvalidBlockIndex &&
            blockRef.current[firstInvalidBlockIndex]
          ) {
            blockRef.current[firstInvalidBlockIndex].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 500);
      }
      setLoading(false);
      return;
    }

    const payloadComplianceDocs = await buildPayload(files);
    //console.log("payloadComplianceDocs", payloadComplianceDocs);
    // const complianceDocsPayload = payloadComplianceDocs.map((doc) => ({
    //   complianceType: doc.complianceType,
    //   complianceFileName: doc.complianceFileName,
    //   complianceFile: doc.base64, // you must convert file to base64 before this step
    // }));

    // if (!propertyName.trim()) {
    //   nameRef.current.style.border = "2px solid red";
    // }
    // if (!propertyAddress.trim()) {
    //   addressRef.current.style.border = "2px solid red";
    // }
    // if (!propertyPostalCode.trim()) {
    //   postalCodeRef.current.style.border = "2px solid red";
    // }
    // if (!propertyCity.trim()) {
    //   cityRef.current.style.border = "2px solid red";
    // }

    const formDataToUploadProperty = new FormData();
    // formDataToUploadProperty.append("File", propertImage);
    formDataToUploadProperty.append("ClientId", clientObj?.clientId);
    formDataToUploadProperty.append("propertyName", propertyName);
    formDataToUploadProperty.append("propertyAddress", propertyAddress);
    formDataToUploadProperty.append("PostalCode", propertyPostalCode);
    // formDataToUploadProperty.append("CityId", propertyCity);
    if (propertyCity === "add-new") {
      formDataToUploadProperty.append("CityId", 0);
      formDataToUploadProperty.append("IsNewCity", true);
      formDataToUploadProperty.append("CityName", newCityName.trim());
    } else {
      formDataToUploadProperty.append("CityId", propertyCity);
      formDataToUploadProperty.append("IsNewCity", false);
      formDataToUploadProperty.append("CityName", "");
    }
    formDataToUploadProperty.append("NumberOfBlocks", numberofBlocks);
    formDataToUploadProperty.append("Latitude", siteLatitude);
    formDataToUploadProperty.append("Longitude", siteLongitude);

    // formDataToUploadProperty.append(
    //   "TotalNoOfFloors",
    //   totalFloor === undefined || totalFloor === "" ? "" : String(totalFloor)
    // );
    formDataToUploadProperty.append("PropertyStatus", propertyStatus);
    const selectedInspector = propertyInspector?.map((u) => u.value);
    selectedInspector.forEach((value) => {
      formDataToUploadProperty.append("InspectorIds[]", value); // Use '[]' in the key for server-side parsing as an array
    });
    //formDataToUploadProperty.append("InspectorIds", selectedInspector);
    const selectApprover = propertyApprover?.map((u) => u.value);
    selectApprover.forEach((value) => {
      formDataToUploadProperty.append("ApproverIds[]", value); // Use '[]' in the key for server-side parsing as an array
    });
    //  NEW CLIENT NAME FROM INPUT
    if (newClientName && newClientName.trim()) {
      formDataToUploadProperty.append(
        "companyClientName",
        newClientName.trim(),
      );
    }

    // formDataToUploadProperty.append("ApproverIds", selectApprover);
    // formDataToUploadProperty.append(
    //   "BlockName",
    //   propertyBlockObj?.blockName || ""
    // );
    // formDataToUploadProperty.append("blockId", propertyBlockObj?.blockId || "");
    // complianceType: fe.type, // from dropdown
    //     complianceFileName: fe.docName, // editable name
    //     complianceFile: fe.file,
    // formDataToUploadProperty.append(
    //   "complianceDocs",
    //   JSON.stringify(payloadComplianceDocs)
    // );
    if (files?.length > 0) {
      files?.forEach((fileObj, index) => {
        formDataToUploadProperty.append(
          `complianceDocs[${index}].complianceType`,
          fileObj.type || 0,
        );
        formDataToUploadProperty.append(
          `complianceDocs[${index}].complianceFileName`,
          fileObj.docName,
        );
        formDataToUploadProperty.append(
          `complianceDocs[${index}].complianceFile`,
          fileObj.file,
        ); //this is file obj
      });
    } else {
      formDataToUploadProperty.append(`complianceDocs`, null);
    }
    console.log(
      "formDataToUploadProperty",
      formDataToUploadProperty,
      payloadComplianceDocs,
    );

    // EXISTING CLIENT SELECTED
    if (selectedClient && selectedClient !== "add-new") {
      formDataToUploadProperty.append("companyClientMappingId", selectedClient);
    }

    // NEW CLIENT ENTERED
    if (newClientName && newClientName.trim()) {
      formDataToUploadProperty.append(
        "companyClientName",
        newClientName.trim(),
      );
    }

    try {
      const response = await fetch(hostName + ADD_PROPERTY_BY_CLIENT_ID, {
        method: "POST",
        body: formDataToUploadProperty,
        headers: {
          Authorization: "Bearer " + userObj?.token,
          Accept: "application/json",
        },
      });

      const data = await response.json();
      if (response?.status === 401) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: data?.message,
        });
        setTimeout(() => {
          window.location.href = generatePath("/client/:clientNameParam/", {
            clientNameParam,
          });
        }, 2000);
      }
      if (response.status === 200) {
        const PropertyMasterID = getPropertyId(data.response.message);
        const formDataToUploadBlocks = new FormData();
        formDataToUploadBlocks.append("PropertyMasterId", PropertyMasterID);
        blockData.forEach((block, index) => {
          console.log("block", block.blockName);
          formDataToUploadBlocks.append(
            `Blocks[${index}].BlockName`,
            block.blockName,
          );
          formDataToUploadBlocks.append(
            `Blocks[${index}].TotalFloors`,
            block.totalFloors,
          );
          formDataToUploadBlocks.append(
            `Blocks[${index}].BuildingImage`,
            block.buildingImage || "",
          );
          formDataToUploadBlocks.append(
            `Blocks[${index}].BuildingImageUrl`,
            "",
          );
          block.floorArray?.forEach((floor, ind) => {
            console.log("block", block.blockName, floor.floor, floor.image);
            formDataToUploadBlocks.append(
              `Blocks[${index}].FloorNumbers[${ind}]`,
              floor.floor,
            );
            formDataToUploadBlocks.append(
              `Blocks[${index}].FloorImages[${ind}]`,
              floor.image || "",
            );
            formDataToUploadBlocks.append(
              `Blocks[${index}].FloorImagesUrl[${ind}]`,
              "",
            );
          });
          block.additionalDocsArr.length > 0 &&
            block.additionalDocsArr.forEach((doc, ind) => {
              console.log("block", block.blockName, doc.docName);

              formDataToUploadBlocks.append(
                `Blocks[${index}].DocumentTypes[${ind}]`,
                doc.type,
              );
              formDataToUploadBlocks.append(
                `Blocks[${index}].DocumentFileNames[${ind}]`,
                doc.docName,
              );
              formDataToUploadBlocks.append(
                `Blocks[${index}].DocumentFiles[${ind}]`,
                doc.file,
              );
            });
        });

        // const floorPlanFiles = await Promise.all(
        //   floorEntries.map(async (entry) => {
        //     let base64Image = "";
        //     if (entry.image) {
        //       base64Image = entry.image;
        //     }
        //     return {
        //       floorNumber: Number(entry.floor) || 0,
        //       floorImage: base64Image,
        //     };
        //   })
        // );
        // floorPlanFiles.forEach((fileObj, index) => {
        //   formDataToUploadFloorPlan.append(
        //     `floorPlanFiles[${index}].FloorNumber`,
        //     fileObj.floorNumber
        //   );
        //   formDataToUploadFloorPlan.append(
        //     `floorPlanFiles[${index}].FloorImage`,
        //     fileObj.floorImage
        //   ); // This is a File object
        // });
        // formDataToUploadFloorPlan.append(
        //   "floorPlanFiles",
        //   JSON.stringify(floorPlanFiles)
        // );
        // formDataToUploadFloorPlan.append("ClientId", clientObj.clientId);
        // formDataToUploadFloorPlan.append("PropertyMasterID", PropertyMasterID);
        try {
          const responseCreateBlocks = await fetch(hostName + CREATE_BLOCKS, {
            method: "POST",
            body: formDataToUploadBlocks,
            headers: {
              Authorization: "Bearer " + userObj?.token,
            },
          });
          const responseCreateBlocksData = await responseCreateBlocks.json();
          if (responseCreateBlocksData?.status === 401) {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: data?.message,
            });
            setTimeout(() => {
              window.location.href = generatePath("/client/:clientNameParam/", {
                clientNameParam,
              });
            }, 2000);
          }
          if (responseCreateBlocksData?.isError) {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: responseCreateBlocksData?.message,
            });
            handleResetAddPropertyForm();
          }
          if (responseCreateBlocks?.status === 200) {
            setTimeout(() => {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString: "Site has been successfully added.",
              });
            }, 100);
            setLoading(false);
          }
        } catch (error) {
          return error;
        }
        //handleGetAllPropertyByClinetID(clientObj.clientId);
      } else if (response.status === 400) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: data?.message,
        });
      } else {
        throw new Error(`HTTP error! status: ${response}`);
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
      handleResetAddPropertyForm();
      setActiveTab("Site");
      // setSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "." || e.key === "e" || e.key === "-") {
      e.preventDefault();
    }
  };
  // const handleFloorInputChange = (event) => {
  //   const inputValue = event.target.value;
  //   // Remove any non-digit characters (including decimal points)
  //   const integerValue = inputValue.replace(/[^0-9]/g, "");
  //   if (integerValue > 0) {
  //     setShowFloorImages(true);
  //   } else {
  //     setShowFloorImages(false);
  //   }
  //   setTotalFloor(integerValue);
  // };
  // const handleFloorInputChange = (e) => {
  //   const digits = e.target.value.replace(/\D/g, ""); // keep only 0–9
  //   const normalized = digits === "" ? "" : String(parseInt(digits, 10)); // "" or int-as-string

  //   setShowFloorImages(normalized !== "" && Number(normalized) > 0);
  //   setTotalFloor(normalized); // IMPORTANT: "" when empty
  // };

  //   const createObjects = (count) => {
  //     const arr = Array.from({ length: count }, (_, i) => ({
  //       id: i + 1,
  //       blockName: "",
  //       totalFloors: 0,
  //       showFloorImages: false,
  //       floorArray: [],
  //       additionalDocsArr: [],
  //       fileError: "",
  //       fileShowValidation: false,
  //     }));
  //     setBlockData(arr);
  //   };

  useEffect(() => {
    setBlockData((prev) => {
      const next = Array.from(
        { length: numberofBlocks },
        (_, i) =>
          prev[i] ?? {
            id: i + 1,
            blockName: "",
            totalFloors: 0,
            showFloorImages: false,
            floorArray: [],
            additionalDocsArr: [],
            fileError: "",
            fileShowValidation: false,
            formErrors: {}, // add these
            hasFormErrors: false,
            buildingImage: null,
            previewBuildingImage: "",
          },
      );
      return next;
    });
  }, [numberofBlocks]);

  const removeBlock = (blockIndex) => {
    setBlockData((prev) => prev.filter((_, i) => i !== blockIndex));
    const value = numberofBlocks === 0 ? 0 : numberofBlocks - 1;
    setNumberofBlocks(value);
  };

  // Update the block data array for a specific block and field.
  const handleBlockDataChange = (index, field, val) => {
    if (field === "totalFloors") {
      let digits = val.replace(/\D/g, ""); // keep only 0–9
      if (digits.length > 3) {
        digits = digits.slice(0, 3);
      }
      const normalized = digits === "" ? "" : String(parseInt(digits, 10));
      const numericValue = normalized === "" ? 0 : Number(normalized);
      const floorarr = Array.from({ length: normalized }, (_, i) => ({
        floorTempid: i + 1, // temp id for React key, not sent to backend
        floor: null,
        image: null,
        floorError: "",
      }));
      setBlockData((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                totalFloors: normalized,
                showFloorImages: normalized !== "" && numericValue > 0,
                floorArray: floorarr,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", //  clear error for this field only
                },
              }
            : item,
        ),
      );
    } else if (field === "additionalDocsArr") {
      setBlockData((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;

          const prevFieldValue = item[field]; // e.g., previous additionalDocsArr

          const nextFieldValue =
            typeof val === "function" ? val(prevFieldValue) : val;

          return { ...item, [field]: nextFieldValue };
        }),
      );
    } else if (field === "buildingImage") {
      const file = val.target.files?.[0] ?? null;
      if (file && file.size > 10 * 1024 * 1024) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "File size should not exceed 10 MB",
        });
        const el = fileInputRefsBuilding.current[index];
        if (el) el.value = "";
        return;
      }
      if (file) {
        const previewUrl = URL.createObjectURL(file);

        setBlockData((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  buildingImage: file,
                  previewBuildingImage: previewUrl,
                }
              : item,
          ),
        );
      }
    } else {
      setBlockData((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                [field]: val,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", // clear error for this field only
                },
              }
            : item,
        ),
      );
    }
  };

  // const handleBlockFloorNumberChange = (blockIndex, floorIndex, value) => {

  //   setBlockData((prev) =>
  //     prev.map((block, i) => {
  //       if (i !== blockIndex) return block;

  //       const nextFloorArray = block.floorArray.map((f) =>
  //         f.floorTempid === floorIndex ? { ...f, floor: value, floorError: "" } : f,
  //       );

  //       return {
  //         ...block,
  //         floorArray: nextFloorArray,
  //       };
  //     }),
  //   );
  // };

  const handleBlockFloorNumberChange = (blockIndex, floorIndex, value) => {
    if (value === "") {
      setBlockData((prev) =>
        prev.map((block, i) => {
          if (i !== blockIndex) return block;

          const nextFloorArray = block.floorArray.map((f) =>
            f.floorTempid === floorIndex
              ? { ...f, floor: value, floorNumberError: "" }
              : f,
          );

          return {
            ...block,
            formErrors: {
              ...block.formErrors,
              floorNumbers: "", // clear floor number error when user clears input
            },
            floorArray: nextFloorArray,
          };
        }),
      );
      return;
    }

    let numericValue;
    //check if valid

    if (/^-?\d*\.?\d*$/.test(value)) {
      if (Number(value) >= -2) {
        numericValue = Number(value);
      } else {
        numericValue = -2;
      }
    }

    // if (Number.isNaN(numericValue)) return;

    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        let nextValue = numericValue;

        const nextFloorArray = block.floorArray.map((floor) => {
          if (floor.floorTempid < floorIndex) {
            // ✅ floors above stay unchanged
            return floor;
          }

          if (floor.floorTempid === floorIndex) {
            return {
              ...floor,
              floor: numericValue,
              floorNumberError: "",
            };
          }

          // ✅ auto-generate below floors
          nextValue += 1;
          return {
            ...floor,
            floor: nextValue,
            floorNumberError: "",
          };
        });

        return {
          ...block,
          formErrors: {
            ...block.formErrors,
            floorNumbers: "", // clear floor number error when user clears input
          },
          floorArray: nextFloorArray,
        };
      }),
    );
  };

  const handleBlockFloorImageChange = (blockIndex, floorNumber, e) => {
    const file = e.target.files?.[0] ?? null;

    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          f.floorTempid === floorNumber
            ? { ...f, image: file, floorError: "" }
            : f,
        );

        return {
          ...block,
          floorArray: nextFloorArray,
          fileError: "",
          fileShowValidation: false,
        };
      }),
    );
  };

  const removeFloorImage = (blockIndex, floorNumber) => {
    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          f.floorTempid === floorNumber ? { ...f, image: null } : f,
        );

        return { ...block, floorArray: nextFloorArray };
      }),
    );

    const el = fileInputRefs.current[blockIndex]?.[floorNumber];
    if (el) el.value = "";
  };

  // for building image code

  const removeBuildingImage = (blockIndex) => {
    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        return { ...block, buildingImage: null, previewBuildingImage: "" };
      }),
    );
    const el = fileInputRefsBuilding.current[blockIndex];
    if (el) el.value = "";
  };

  const fileInputRefs = useRef({}); // nested map: { [blockIndex]: { [floorNumber]: HTMLInputElement } }
  // for building image code
  const fileInputRefsBuilding = useRef({}); // map: { [blockIndex]: HTMLInputElement }

  const setFileInputRef = (blockIndex, floorNumber) => (el) => {
    if (!el) return;
    if (!fileInputRefs.current[blockIndex])
      fileInputRefs.current[blockIndex] = {};
    fileInputRefs.current[blockIndex][floorNumber] = el;
  };

  // for building image code
  const setFileInputRefBuilding = (blockIndex) => (el) => {
    if (!el) return;
    if (!fileInputRefsBuilding.current[blockIndex])
      fileInputRefsBuilding.current[blockIndex] = {};
    fileInputRefsBuilding.current[blockIndex] = el;
  };

  // const [saving, setSaving] = useState(false);
  // const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <div className="dashboard_body_main paddingClassForAddProperty">
        {hideSidebar ? (
          <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar} />
        ) : (
          <SidebarIcons
            setHideSidebar={setHideSidebar}
            hideSidebar={hideSidebar}
          />
        )}
        <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
          <div className="dashboard_header">
            <h2 className="mb-0">Add New Site</h2>
            <div className="d-flex flex-row justify-content-between">
              <p className="header-description">
                Complete the form to add a new site/building.
              </p>
            </div>
          </div>
          <div className="mb-3 mt-2 tab-container">
            <button
              className={
                activeTab === "Site" ? "btn btn-tab-active" : "btn btn-tab"
              }
              onClick={() => handleTabChange("Site")}
            >
              Site Information
            </button>
            <button
              className={
                activeTab === "Block" ? "btn btn-tab-active" : "btn btn-tab"
              }
              onClick={() => handleTabChange("Block")}
            >
              Building Information
            </button>
          </div>
          {activeTab === "Site" && (
            <>
              <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
                <h3 className="resident-card-header">Site Information</h3>
                <div className="card-body-uneven-section">
                  <div className="form-group">
                    <label htmlFor="name">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter site name"
                      id={`name1`}
                      className={errors.siteName ? "input-error" : ""}
                      value={propertyName}
                      onChange={(e) => {
                        setPropertName(e.target.value);
                        nameRef.current.style.border = "";
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          siteName: e.target.value ? "" : prevErrors.siteName,
                        }));
                      }}
                      ref={nameRef}
                    />
                    {errors.siteName && (
                      <span className="formError">{errors.siteName}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="address">
                      Address <span style={{ color: "red" }}>*</span>
                    </label>

                    <input
                      type="text"
                      placeholder="Enter site address"
                      id="address"
                      className={errors.address ? "input-error" : ""}
                      value={propertyAddress}
                      onChange={(e) => {
                        setPropertAddress(e.target.value);

                        addressRef.current?.style &&
                          (addressRef.current.style.border = "");

                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          address: e.target.value ? "" : prevErrors.address,
                        }));
                      }}
                      ref={addressRef}
                    />

                    {errors.address && (
                      <span className="formError">{errors.address}</span>
                    )}
                  </div>

                  {/* <div className="form-group" ref={addressRef} style={{ position: "relative" }}>
                  <label htmlFor="address1">
                    Address <span style={{ color: "red" }}>*</span>
                  </label>
                    <input
                    type="text"
                    placeholder="Enter site address"
                    id="address"
                    className={errors.address ? "input-error" : ""}
                    value={propertyAddress}
                    onChange={(e) => {
                      setPropertAddress(e.target.value);
                      handleAddressSearch(e.target.value);
                      addressRef.current.style.border = "";
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        address: e.target.value ? "" : prevErrors.address,
                      }));
                    }}
                    
                  />
                  {showSuggestions && (
                    <ul
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        maxHeight: "220px",
                        marginTop: "4px",
                        padding: 0,
                        listStyle: "none",
                        backgroundColor: "#fff",
                        border: "1px solid #dcdcdc",
                        borderRadius: "6px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                        overflowY: "auto",
                        zIndex: 9999,
                      }}
                    >
                      {isLoadingAddress ? (
                        <li
                          style={{
                            padding: "10px 12px",
                            fontSize: "14px",
                            color: "#555",
                          }}
                        >
                          Loading...
                        </li>
                      ) : addressSuggestions.length > 0 ? (
                        addressSuggestions.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => handleSelectAddress(item)}
                            style={{
                              padding: "10px 12px",
                              fontSize: "14px",
                              cursor: "pointer",
                              borderBottom: "1px solid #f0f0f0",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor = "#f5f8ff")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor = "transparent")
                            }
                          >
                            {item.display_name}
                          </li>
                        ))
                      ) : (
                        <li
                          style={{
                            padding: "10px 12px",
                            fontSize: "14px",
                            color: "#555",
                          }}
                        >
                          No Address Found
                        </li>
                      )}
                    </ul>
                  )}

              
                  {errors.address && (
                    <span className="formError">{errors.address}</span>
                  )}
                </div> */}
                </div>
                <div className="card-body-three-section">
                  <div className="form-group">
                    <label htmlFor="contact1">
                      Post code <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter post code"
                      className={errorPostCode ? "input-error" : ""}
                      id={`contact1`}
                      value={propertyPostalCode}
                      onChange={(e) => {
                        let formattedValue = e.target.value
                          .toUpperCase()
                          .replace(/\s+/g, "");
                        if (formattedValue.length > 5) {
                          formattedValue =
                            formattedValue.slice(0, -3) +
                            " " +
                            formattedValue.slice(-3);
                        }
                        setPropertPostalCode(formattedValue);
                        postalCodeRef.current.style.border = "";
                        setErrorPostCode(e.target.value ? "" : errorPostCode);
                      }}
                      ref={postalCodeRef}
                    />

                    {errorPostCode && (
                      <span className="formError">{errorPostCode}</span>
                    )}
                  </div>
                  {/* <div className="form-group">
                  <label htmlFor="contact1">
                    City <span style={{ color: "red" }}>*</span>
                  </label>
                  <AutocompleteInput
                    // masterList={city || []}
                    masterList={[...(city || [])].sort((a, b) =>
                      (a.cityName || "").localeCompare(
                        b.cityName || "",
                        undefined,
                        {
                          sensitivity: "base",
                        },
                      ),
                    )}
                    getOptionLabel={(c) => c?.cityName || ""}
                    getOptionValue={(c) => c?.cityId || ""}
                    placeholder="Select City"
                    inputClassName={errors.cityid ? "input-error" : ""}
                    wrapperClassName=""
                    notFoundText="City not found"
                    id={`floor-select`}
                    className={
                      errors.cityid ? "input-error form-select" : "form-select"
                    }
                    value={propertyCity}
                    onValueChange={(val) => {
                      handleCityChange(val);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        cityid: val ? "" : prevErrors.cityid,
                        // cityid: val.target.value ? "" : prevErrors.cityId,
                      }));
                    }}
                    aria-label="Floating label select example"
                    inputRef={cityRef}
                  />
                  {errors.cityid && (
                    <span className="formError">{errors.cityid}</span>
                  )}
                </div> */}

                  <div className="form-group">
                    <label>
                      City <span style={{ color: "red" }}>*</span>
                    </label>

                    {!showNewCityInput ? (
                      <div style={{ position: "relative" }}>
                        <AutocompleteInput
                          masterList={cityOptions}
                          getOptionLabel={(c) => c?.cityName || ""}
                          getOptionValue={(c) => c?.cityId || ""}
                          placeholder="Select City"
                          notFoundText="City not found"
                          inputClassName={errors.cityid ? "input-error" : ""}
                          value={propertyCity}
                          onValueChange={(val) => {
                            if (val === "add-new") {
                              setShowNewCityInput(true);
                              setPropertyCity("add-new");
                              return;
                            }

                            handleCityChange(val);
                            setErrors((prev) => ({ ...prev, cityid: "" }));
                          }}
                          inputRef={cityRef}
                        />

                        {/* <div
                        style={{
                          position: "absolute",
                          top: "38px", // same height as input
                          left: 0,
                          width: "100%",
                          background: "#fff",
                          border: "1px solid #ddd",
                          borderTop: "none",
                          zIndex: 20,
                        }}
                      ></div> */}
                      </div>
                    ) : (
                      <input
                        type="text"
                        placeholder="City Name"
                        className={cityError ? "input-error" : ""}
                        value={newCityName}
                        onChange={(e) => {
                          const value = e.target.value;
                          setNewCityName(value);
                          setCityError("");

                          if (!value.trim()) {
                            setShowNewCityInput(false);
                            setPropertyCity("");
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();

                            if (!newCityName.trim()) {
                              setCityError("City name cannot be empty");
                              return;
                            }

                            setPropertyCity("add-new");
                            setShowNewCityInput(false);
                          }

                          if (e.key === "Escape") {
                            setShowNewCityInput(false);
                            setNewCityName("");
                            setPropertyCity("");
                          }
                        }}
                        ref={cityRef}
                      />
                    )}

                    {errors.cityid && (
                      <span className="formError">{errors.cityid}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="contact1">Select Site Status</label>
                    <select
                      id={`floor-select-`}
                      className="form-select"
                      value={propertyStatus}
                      onChange={(e) => setPropertyStatus(e.target.value)}
                      aria-label="Floating label select example"
                    >
                      <option selected value="Active">
                        Active
                      </option>
                      <option value="Archive">Archive</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">
                      Number of Buildings{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter number of building "
                      id={`name1`}
                      className={errors.numberofBlocks ? "input-error" : ""}
                      value={numberofBlocks}
                      onChange={(e) => {
                        let inputValue = e.target.value;
                        inputValue = inputValue.replace(/[^0-9]/g, "");
                        if (inputValue.length > 1) {
                          inputValue = inputValue.replace(/^0+/, "") || "0";
                        }
                        const value =
                          inputValue === "" ? 0 : parseInt(inputValue) || 0;
                        setNumberofBlocks(value);
                        numberofBlocksref.current.style.border = "";
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          numberofBlocks: value
                            ? ""
                            : prevErrors.numberofBlocks,
                        }));
                      }}
                      ref={numberofBlocksref}
                    />
                    {errors.numberofBlocks && (
                      <span className="formError">{errors.numberofBlocks}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Latitude</label>
                    <input
                      type="text"
                      placeholder="e.g., 53.483959"
                      id={`name1`}
                      value={siteLatitude}
                      className={errors.siteLatitude ? "input-error" : ""}
                      onChange={(e) => {
                        setSiteLatitude(e.target.value);
                        latitudeRef.current.style.border = "";
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          siteLatitude: e.target.value
                            ? ""
                            : prevErrors.siteLatitude,
                        }));
                      }}
                      ref={latitudeRef}
                    />
                    {errors.siteLatitude && (
                      <span className="formError">{errors.siteLatitude}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Longitude</label>
                    <input
                      type="text"
                      placeholder="e.g., -2.244644"
                      className={errors.siteLongitude ? "input-error" : ""}
                      id={`name1`}
                      value={siteLongitude}
                      onChange={(e) => {
                        setSiteLongitude(e.target.value);
                        longitudeRef.current.style.border = "";
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          siteLongitude: e.target.value
                            ? ""
                            : prevErrors.siteLongitude,
                        }));
                      }}
                      ref={longitudeRef}
                    />
                    {errors.siteLongitude && (
                      <span className="formError">{errors.siteLongitude}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="contact1">
                      Select Inspector(s)
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      isMulti
                      // options={inspectorList}
                      options={[...(inspectorList || [])].sort((a, b) =>
                        (a.label || "").localeCompare(
                          b.label || "",
                          undefined,
                          {
                            sensitivity: "base",
                          },
                        ),
                      )}
                      value={propertyInspector}
                      required
                      ref={inspectorRef}
                      className={errors.inspector ? "input-error" : ""}
                      onChange={(e) => {
                        setPropertyInspector(e);
                        inspectorRef.current?.controlRef?.style?.setProperty(
                          "border",
                          "1px solid #ccc",
                        );
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          inspector: "",
                        }));
                      }}
                      placeholder="Select Inspector"
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                          height: "2.81rem",
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: "2.81rem",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          textAlign: "left",
                          marginLeft: "1rem",
                          color: "#a3a3a3",
                          opacity: 0.8,
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />
                    {errors.inspector && (
                      <span className="formError">{errors.inspector}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="contact1">
                      Select Approver(s)
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      isMulti
                      className={errors.approvers ? "input-error" : ""}
                      // options={approverList}
                      options={[...(approverList || [])].sort((a, b) =>
                        (a.label || "").localeCompare(
                          b.label || "",
                          undefined,
                          {
                            sensitivity: "base",
                          },
                        ),
                      )}
                      value={propertyApprover}
                      required
                      onChange={(e) => {
                        approverRef.current?.controlRef?.style?.setProperty(
                          "border",
                          "",
                        );
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          approvers: "",
                        }));
                        setPropertyApprover(e);
                      }}
                      placeholder="Select Approvers"
                      isClearable
                      ref={approverRef}
                      menuPortalTarget={document.body}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                          height: "2.81rem",
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: "2.81rem",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          textAlign: "left",
                          marginLeft: "1rem",
                          color: "#a3a3a3",
                          opacity: 0.8,
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />
                    {errors.approvers && (
                      <span className="formError">{errors.approvers}</span>
                    )}
                  </div>
                  {/* <div className="form-group">
                  <label htmlFor="contact1">Main door Image</label>
                  <div
                    className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                  >
                    <label
                      className="input-group-text mb-0"
                      htmlFor="inputGroupFile"
                      style={{
                        fontSize: "15px",
                        lineHeight: 2,
                        color: " #081634",
                        backgroundColor: "white",
                        border: "1px solid #081634",
                        borderRadius: "5px",
                      }}
                    >
                      Choose File
                    </label>
                    <input
                      type="file"
                      id="inputGroupFile"
                      accept=".jpg, .jpeg, .png, .gif"
                      onChange={handleFileChange}
                      ref={fileInputRef}
                    />
                  </div>
                  {previewPropertImage && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-600 mb-1">Preview:</p>
                      <img
                        height="150px"
                        width="150px"
                        src={previewPropertImage}
                        alt="Main Door"
                        className="w-48 h-48 object-cover rounded-lg border"
                      />
                    </div>
                  )}
                </div> */}

                  <div className="form-group">
                    <label htmlFor="selectClient">
                      Select Client
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </label>
                    {!showNewClientInput ? (
                      <select
                        id="selectClient"
                        className={
                          clientError || errors.client
                            ? "form-select input-error"
                            : "form-select"
                        }
                        value={selectedClient}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "add-new") {
                            setShowNewClientInput(true);
                            setSelectedClient(value);
                            setClientError("");
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              client: "",
                            }));
                          } else if (value === "") {
                            // User cleared the selection
                            setSelectedClient(value);
                            setShowNewClientInput(false);
                            setNewClientName("");
                            setClientError("");
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              client: "",
                            }));
                            if (clientRef.current) {
                              clientRef.current.style.border = "";
                            }
                          } else {
                            setSelectedClient(value);
                            setShowNewClientInput(false);
                            setNewClientName("");
                            setClientError("");
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              client: "",
                            }));
                            if (clientRef.current) {
                              clientRef.current.style.border = "";
                            }
                          }
                        }}
                        ref={clientRef}
                        aria-label="Select Client"
                      >
                        <option value="">Select Client</option>
                        <option value="add-new" className="fw-bold">
                          ➕ Add New Client
                        </option>
                        {clientsList.map((client) => (
                          <option
                            key={client.companyClientMappingId}
                            value={client.companyClientMappingId}
                          >
                            {client.companyClientName}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        placeholder="Enter new client name"
                        className={
                          clientError || errors.client ? "input-error" : ""
                        }
                        value={newClientName}
                        onChange={(e) => {
                          const value = e.target.value;
                          setNewClientName(value);
                          setClientError("");
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            client: "",
                          }));

                          // If text is cleared, show dropdown again
                          if (!value || value.trim() === "") {
                            setShowNewClientInput(false);
                            setSelectedClient("");
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();

                            const trimmedName = newClientName.trim();
                            if (!trimmedName) {
                              setClientError("Client name cannot be empty");
                              return;
                            }

                            //  DO NOT clear newClientName
                            setSelectedClient("add-new");
                            setShowNewClientInput(false);
                          }

                          if (e.key === "Escape") {
                            setShowNewClientInput(false);
                            setNewClientName("");
                            setSelectedClient("");
                            setClientError("");
                          }
                        }}
                        ref={clientRef}
                      />
                    )}
                    {/* {clientError && (
                    <span className="formError">{clientError}</span>
                  )}*/}
                    {errors.client && (
                      <span className="formError">{errors.client}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
                <h3 className="resident-card-header">Site Documents</h3>
                <FileUpload
                  setFiles={setFiles}
                  files={files}
                  setError={setError}
                  error={error}
                  setShowValidation={setShowValidation}
                  showValidation={showValidation}
                />
              </div>
            </>
          )}
          {activeTab === "Block" &&
            blockData.length > 0 &&
            blockData.map((block, index) => {
              return (
                <div
                  key={index}
                  className="resident-card d-flex flex-column gap-2 mt-3 text-start"
                >
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <h3 className="resident-card-header">
                      Building - {index + 1}
                    </h3>
                    <span
                      style={{ fontSize: "1.5rem", cursor: "pointer" }}
                      aria-label="Remove Building"
                      title="Remove Building"
                      onClick={() => removeBlock(index)}
                    >
                      {" "}
                      &times;
                    </span>
                  </div>
                  <div className="card-body-section">
                    <div className="form-group">
                      <label htmlFor="name">
                        Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        ref={(el) => (blockRef.current[block.id] = el)}
                        type="text"
                        className={
                          block.formErrors?.blockName ? "input-error" : ""
                        }
                        placeholder="Enter building name"
                        id={`Building${index + 1}`}
                        name="blockName"
                        value={block.blockName}
                        onChange={(e) => {
                          handleBlockDataChange(
                            index,
                            "blockName",
                            e.target.value,
                          );
                        }}
                      />

                      {block.formErrors?.blockName && (
                        <div className="formError">
                          {block.formErrors.blockName}
                        </div>
                      )}
                    </div>
                    {/* // for building image code  */}
                    <div className="form-group">
                      <label htmlFor="contact1">Building Image</label>
                      <div
                        className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                      >
                        <label
                          className="input-group-text mb-0"
                          htmlFor={`inputGroupFileBlock-${index}`}
                          style={{
                            fontSize: "15px",
                            lineHeight: 2,
                            color: " #081634",
                            backgroundColor: "white",
                            border: "1px solid #081634",
                            borderRadius: "5px",
                          }}
                        >
                          Choose File
                        </label>
                        <input
                          type="file"
                          id={`inputGroupFileBlock-${index}`}
                          accept=".jpg, .jpeg, .png, .gif, .pdf"
                          onChange={(e) =>
                            handleBlockDataChange(index, "buildingImage", e)
                          }
                          ref={setFileInputRefBuilding(index)}
                        />
                        <img
                          src={delicon}
                          alt="Delete"
                          onClick={() =>
                            block?.buildingImage && removeBuildingImage(index)
                          }
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: block?.buildingImage
                              ? "pointer"
                              : "not-allowed",
                            marginLeft: "1rem",
                            opacity: block?.buildingImage ? 1 : 0.4,
                          }}
                        />
                      </div>
                      {block?.previewBuildingImage && (
                        <div className="mt-2">
                          {block?.buildingImage?.type === "application/pdf" ? (
                            <p className="text-sm text-gray-600 mb-1">
                              Preview:{" "}
                              <a
                                href={block.previewBuildingImage}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {block?.buildingImage?.name || "View PDF"}
                              </a>
                            </p>
                          ) : (
                            <>
                              <p className="text-sm text-gray-600 mb-1">
                                Preview:
                              </p>
                              <img
                                height="150px"
                                width="150px"
                                src={block.previewBuildingImage}
                                alt="Building Image"
                                className="w-48 h-48 object-cover rounded-lg border"
                              />
                            </>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="name">
                        Total Floors <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        className={
                          block.formErrors?.totalFloors ? "input-error" : ""
                        }
                        placeholder="Enter total floors"
                        id={`name1`}
                        name="totalFloors"
                        value={block.totalFloors}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => {
                          handleBlockDataChange(
                            index,
                            "totalFloors",
                            e.target.value,
                          );
                        }}
                      />
                      {block.formErrors?.totalFloors && (
                        <div className="formError">
                          {block.formErrors.totalFloors}
                        </div>
                      )}
                    </div>
                  </div>
                  {block.floorArray.length > 0 &&
                    block.floorArray.map((floor, i) => {
                      return (
                        <div key={i} className="card-body-section">
                          <div className="form-group">
                            <label htmlFor="name">
                              Floor Number{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              pattern="[0-9]*"
                              inputMode="numeric"
                              disabled={i !== 0}
                              step={1}
                              min={-2}
                              className={
                                floor.floorNumberError ? "input-error" : ""
                              }
                              placeholder="Enter Floor Number"
                              id={`name1`}
                              name="Floornumber"
                              value={floor.floor}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "e" ||
                                  e.key === "." ||
                                  (e.key === "-" &&
                                    e.target.value.includes("-"))
                                ) {
                                  e.preventDefault(); // Prevent invalid characters
                                }
                              }}
                              onChange={(e) => {
                                handleBlockFloorNumberChange(
                                  index,
                                  floor.floorTempid,
                                  e.target.value,
                                );
                              }}
                            />
                            {floor.floorNumberError && (
                              <div className="formError">
                                {floor.floorNumberError}
                              </div>
                            )}
                          </div>
                          <div className="form-group">
                            <label htmlFor="contact1">Floor Plan Image </label>
                            <div
                              className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                            >
                              <label
                                className="input-group-text mb-0"
                                htmlFor={`inputGroupFile-${index}-${floor.floorTempid}`}
                                style={{
                                  // height: "36px",
                                  fontSize: "15px",
                                  lineHeight: 2,
                                  color: " #081634",
                                  backgroundColor: "white",
                                  border: "1px solid #081634",
                                  borderRadius: "5px",
                                }}
                              >
                                Choose File
                              </label>
                              <input
                                type="file"
                                className={
                                  floor.floorError ? "input-error" : ""
                                }
                                id={`inputGroupFile-${index}-${floor.floorTempid}`}
                                accept=".jpg, .jpeg, .png, .gif, .pdf"
                                ref={setFileInputRef(index, floor.floorTempid)}
                                onChange={(e) => {
                                  handleBlockFloorImageChange(
                                    index,
                                    floor.floorTempid,
                                    e,
                                  );
                                }}
                              />
                              {/* <img
                              src={delicon}
                              alt="Delete"
                              onClick={() =>
                                removeFloorImage(index, floor.floor)
                              }
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                                marginLeft: "1rem",
                              }}
                            /> */}
                              <img
                                src={delicon}
                                alt="Delete"
                                onClick={() =>
                                  floor.image &&
                                  removeFloorImage(index, floor.floorTempid)
                                }
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: floor.image
                                    ? "pointer"
                                    : "not-allowed",
                                  marginLeft: "1rem",
                                  opacity: floor.image ? 1 : 0.4,
                                }}
                              />
                            </div>
                            {floor.floorError && (
                              <div className="formError">
                                {floor.floorError}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  {block.formErrors?.floorNumbers && (
                    <div className="form-group">
                      <div className="formError">
                        {block.formErrors.floorNumbers}
                      </div>
                    </div>
                  )}

                  {/* <h3 className="resident-card-header mt-2">
                  Additional documents
                </h3> */}
                  {/* <FileUpload
                  setFiles={(files) => {
                    handleBlockDataChange(index, "additionalDocsArr", files);
                  }}
                  files={block.additionalDocsArr}
                  setError={(err) => {
                    handleBlockDataChange(index, "fileError", err);
                  }}
                  error={block.fileError}
                  setShowValidation={(val) => {
                    handleBlockDataChange(index, "fileShowValidation", val);
                  }}
                  showValidation={block.fileShowValidation}
                /> */}
                </div>
              );
            })}

          {/*  Add New Building Blocks*/}

          {activeTab === "Block" && (
            <>
              {errors.buildingRequired && (
                <div className="form-group">
                  <span className="formError">{errors.buildingRequired}</span>
                </div>
              )}
              <button
                type="button"
                className="btn btn-primary custom_toolbar_btn col-3 mx-2 mt-3"
                onClick={() => {
                  const tempBuilding = numberofBlocks;
                  if (isNaN(tempBuilding)) {
                    setNumberofBlocks(1);
                  } else {
                    const value = tempBuilding + 1;
                    setNumberofBlocks(value);
                  }
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    buildingRequired: "",
                  }));
                }}
              >
                <i className=" fa-solid fa-plus addBlock"></i> Add New Building
              </button>
            </>
          )}

          {/* {activeTab === "Block" && blockData.length === 0 && (
          <div className="mt-3">
            Please enter the number of buildings in Site Information.
          </div>
        )} */}

          <div className="button-container align-items-center">
            <button
              type="submit"
              className="btn-primary  col-sm-5 col-md-2"
              //   style={{ width: "120px", marginRight: "10px" }}
              // onClick={handleSaveProperty}
              onClick={() => {
                setShowConfirmationPopup({
                  ...showConfirmationPopup,
                  show: true,
                  headingText: "Confirm Site Addition",
                  infoText:
                    "Kindly review and confirm the floor numbers for all buildings before proceeding. After submission, floor numbers will no longer be editable.",
                  cancelText: "Cancel",
                  submittext: "Submit",
                });
              }}
            >
              Submit
            </button>
            <button
              //   type="reset"
              className="btn-secondary  col-sm-5 col-md-2"
              //   style={{ width: "120px" }}
              onClick={() => {
                handleResetAddPropertyForm();
              }}
            >
              Reset
            </button>

            <button
              //   type="cancel"
              className="btn-tertiary  col-sm-5 col-md-2"
              //   style={{ width: "120px" }}
              onClick={() => {
                handleResetAddPropertyForm();
                // props.handleGetAllPropertyByClinetID(props.clientId);
                // props.setRenderAddProperty(false);
                navigate(-1);
              }}
            >
              Cancel
            </button>

            {validationFlag && (
              <div style={{ color: "red" }} className="me-auto">
                * Please fill all required fields
              </div>
            )}
          </div>

          {/* {
          <div className="row m-0 p-0 mt-4 mb-3">
            <div className="card bulid_card border-0">
              <div className="col-12 col-sm-10 col-lg-8 mb-3 mt-4 ps-3">
                <h5 className="text-start">Floor Images</h5>
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                style={{
                  width: "180px",
                  fontSize: "10px",
                  marginBottom: "20px",
                }}
                onClick={handleAddFloor}
                disabled={floorEntries.length == totalFloor}
              >
                <i
                  className=" fa-solid fa-plus addFloorPlanButton"
                  title=" Add Floor image"
                  onClick={() => {
                    // setShowAddBlockModal(true);
                  }}
                >
                  Add Floor Plan Image
                </i>
              </button>
              {console.log("Floor Entries value ", floorEntries)}
              {floorEntries?.map((entry, index) => (
                // eslint-disable-next-line react/jsx-key
                <div className="row mt-2 ps-3 ">
                  <div className="mb-4" style={{ width: "50%" }}>
                    <select
                      className={
                        entry.requireFloor
                          ? "form-select input-error"
                          : "form-select"
                      }
                      id={`floor-select-${index}`}
                      value={entry.floor}
                      onChange={(e) => handleFloorChange(index, e.target.value)}
                      aria-label="Floating label select example"
                    >
                      <option selected>Select Floor</option>
                      {floorOptions.map((floor) => {
                        const floors = floorEntries?.map(
                          (floor) => floor.floor
                        );
                        const isSelectedElsewhere =
                          floors.includes(floor.toString()) &&
                          entry.floor !== floor.toString(); // allow current selection
                        return (
                          <option
                            disabled={isSelectedElsewhere}
                            key={floor}
                            value={floor}
                          >
                            {floor}
                          </option>
                        );
                      })}
                    </select>

                    {entry.requireFloor && (
                      <span className="formError">{entry.requireFloor}</span>
                    )}
                  </div>

                  <div
                    className="mb-3 d-flex flex-row justify-content-between align-items-start"
                    style={{ width: "50%" }}
                  >
                    <div>
                      <div className="d-flex gap-2">
                        <input
                          type="file"
                          className={
                            entry.requireImage
                              ? "input-error form-control"
                              : "form-control"
                          }
                          // style={{
                          //   height: "36px",
                          //   border: "none",
                          //   color: "#6B7280",
                          // }}
                          // accept=".pdf, .dwg, .jpg, .png, .jpeg"
                          accept=".jpg, .jpeg, .png, .gif"
                          id={`image-upload-${index}`}
                          ref={(el) => (floorInputRef.current[index] = el)}
                          onChange={(e) =>
                            handleImageChange(index, e.target.files[0])
                          }
                        />
                        {entry.floor && entry.floor != "Select Floor" && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </div>
                      {entry.requireImage && (
                        <span className="formError">{entry.requireImage}</span>
                      )}
                    </div>
                    
                    <div className="px-3">
                      <img
                        src={delicon}
                        alt="Delete"
                        onClick={() => handleRemoveFloor(index)}
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                          marginTop: "10px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        } */}
        </div>
      </div>

      <LoadingComponent loading={loading} />
      <ConfirmationPopup
        show={showConfirmationPopup.show}
        headingText={showConfirmationPopup.headingText}
        infoText={showConfirmationPopup.infoText}
        cancelText={showConfirmationPopup.cancelText}
        submitText={showConfirmationPopup.submittext}
        onCancel={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
        }}
        onSubmit={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
          handleSaveProperty();
        }}
      />
      {showAddBlockModal && (
        <AddBlockModalPopup
          setShowAddBlockModal={setShowAddBlockModal}
          addNewBlockValue={addNewBlockValue}
          setAddNewBlockValue={setAddNewBlockValue}
          handleAddBlock={handleAddBlock}
          hanleSaveBlock={hanleSaveBlock}
        />
      )}

      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
    </>
  );
};

export default AddSiteBlock;
